<template>

    <div class="wrapper">
            <Sidebar />

            <!-- ============================================================== -->
            <!-- Start Page Content here -->
            <!-- ============================================================== -->
            <Header />
            <div class="content-page">
                
                <main class="content">
                    
                    <!-- Start Content-->
                    <div class="container-fluid">
                        <slot />
                    </div>
                    <Toast
                        v-if="toast"
                        :message="toast.message"
                        :bg="toast.bg"
                        :id="toast.id"
                    />
                </main>
            </div>
    </div>
    
    <!--
	<main class="flex-shrink-0 text-center">
        <div class="container">
            <slot />
        </div>
        <Toast
            v-if="toast"
            :message="toast.message"
            :bg="toast.bg"
            :id="toast.id"
        />
    </main>
    <Footer />
    -->
</template>
<style scoped>

</style>
<script>
import Header from "@/Layouts/Header.vue";
import Footer from "@/Layouts/Footer.vue";
import Sidebar from "@/Layouts/partials/sidebar.vue";

import Toast from "@/Components/Toast.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        Header,
        Footer,
        Toast,
        Sidebar
    },
    computed: {
        ...mapGetters(["toast"]),
    },
};
</script>

<style>
.wrapper {
    overflow-y: scroll!important;
}
.content-page {
    margin-left: 200px!important;
    padding: 70px 25px 65px!important;
}
</style>
